<template>
    <!-- se despliega desde modificacion de datos cuando se presiona el btn tomar foto-->
    <v-dialog v-model="isActive" transition="dialog-bottom-transition" width="642"
        :fullscreen="$vuetify.breakpoint.mobile">
        <v-card>
            <v-app-bar flat color="white" height="56">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                            @keydown.esc="cerrarDialogo">
                            <v-icon>{{ icon }}</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
                <v-toolbar-title>{{ titulo }}</v-toolbar-title>
            </v-app-bar>
            <v-divider></v-divider>
            <v-progress-linear v-if="loading" indeterminate height="5" color="orange"></v-progress-linear>
            <v-col class="d-flex flex justify-center">
                <v-btn v-if="!capturado" text absolute color="white" class="mt-5 text-body-1">Haz click
                    en
                    cualquier
                    parte para
                    capturar foto</v-btn>
                <video v-if="!capturado" @click="capture" ref="video">
                </video>
                <canvas width="0" ref="canvas"></canvas>
            </v-col>
            <v-card-text v-if="capturado" class="mt-2">
                <v-col class="d-flex row align-center justify-center">
                    <v-btn @click="cargaFoto" elevation='0' block class="pa-5" color="primary">
                        <v-icon class="mr-2">mdi-check</v-icon>
                        ACEPTAR
                    </v-btn>
                    <v-btn @click="descartar" block text class="mt-1 pa-5" color="primary">
                        <v-icon class="mr-2">mdi-delete-outline</v-icon>
                        DESCARTAR
                    </v-btn>
                </v-col>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>


<script>


import { mapActions, mapGetters } from 'vuex'

export default {

    components: {
        //componentes     

    },
    data() {
        return {
            isActive: false,
            icon: 'mdi-close',

            width: 600,
            height: 600 / 1.33,
            capturado: false,

            //capture: false,
            fotoSubida: false
        }
    },
    props: ['titulo', 'tipo'],


    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('notificaciones', ['loading']),
    },
    methods: {
        ...mapActions(['refreshData']),
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions('preafiliacion', ['addFotoCarnet']),

        //metodos de accion de dialogo
        cerrarDialogo() {
            // cierra el dialogo y elimina las variables almacenadas temporalmente
            // en el store

            //  this.refreshData()
            //se vacia el store itemEdit
            /*  if (this.itemSelected) {
                 this.vaciarItem()
             } */
            this.isActive = false

        },
        abrirDialogo() {
            this.isActive = true
            this.activarVideo()
        },
        cargaFoto() {
            this.$emit('cargadaFoto', true)
            this.showSnack({
                message: 'Archivo guardado correctamente',
                type: '400'
            })
            this.cerrarDialogo()
        },
        descartar() {
            this.capturado = false

            //this.addFotoCarnet('')
            this.activarVideo()
            this.$refs.canvas.width = 0

        },


        //metodos para el manejo del canvas
        async capture() {
            let capture = await navigator.mediaDevices.getUserMedia({ video: { width: 600, height: (600 / 1.33) } });
            let video = this.$refs.video;
            video.srcObject = capture;
            await video.play();
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext('2d');
            canvas.width = this.width;
            canvas.height = this.height;
            /**
            ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
            */
            const sW = 400
            ctx.drawImage(video, 95, 80, sW, sW / 1.33, 0, 0, 600, 600 / 1.33);
            let dataURL = canvas.toDataURL('image/png');
            const arr = dataURL.split(',')
            console.log(arr[1])
            //this.addFotoCarnet(arr[1])
            this.capturado = true
        },
        activarVideo() {
            this.$nextTick(() => {
                let video = this.$refs.video;
                navigator.mediaDevices.getUserMedia({ video: true })
                    .then(stream => {
                        //console.log(stream)
                        video.srcObject = stream
                        video.play()
                    })
            })
        },

    }

}

</script>